import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { LocalHospital } from '@mui/icons-material'
import { inject } from 'mobx-react'
import React from 'react'
import { IStores } from 'src/Stores'
import ResponsiveAppBar from 'src/common/ResponsiveAppBar'
import _ from 'lodash'

interface IProviderSaveStatusModalProps {
  isOpen?: boolean
  closeModal?: () => void
  successCount?: number
  errorClaimIds?: string[]
  providerId?: number
  providerSaveStatusModalOnClosing?: any
}

class ProviderSaveStatusModal extends React.Component<IProviderSaveStatusModalProps> {
  public render() {
    const { isOpen } = this.props

    return (
      <Dialog
        key={this.props.providerId}
        fullWidth={false}
        maxWidth="md"
        open={isOpen!}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            this.close()
          }
        }}
      >
        <DialogTitle style={{ padding: 0 }}>
          <ResponsiveAppBar
            title={'Save Provider Result'}
            pageIcon={<LocalHospital />}
            isModal={true}
          />
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            {`Successfully processed the due date for ${this.props.successCount} claims`}
            {this.props.errorClaimIds?.length ? (
              <div>
                <p>The following claim Id(s) were not able to be processed:</p>
                <ul>
                  {this.props.errorClaimIds.map((item) => {
                    return <li>{item}</li>
                  })}
                </ul>
              </div>
            ) : (
              ''
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.close} data-cy="close">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  private close = () => {
    this.props.closeModal!()
  }
}
const InjectedProviderSaveStatusModal = inject<
  IStores,
  IProviderSaveStatusModalProps,
  Partial<IProviderSaveStatusModalProps>,
  any
>((stores: IStores) => ({
  providerSaveStatusModalOnClosing: stores.providers.providerSaveStatusModalOnClosing,
  isOpen: stores.providers.isProviderSaveStatusModalOpen,
  closeModal: stores.providers.closeProviderSaveStatusModal,
  successCount: stores.providers.successCount,
  errorClaimIds: stores.providers.errorClaimIds,
}))(ProviderSaveStatusModal)

export default InjectedProviderSaveStatusModal
